{
  "nameInput": {
    "placeholder": "Si e ke emrin?"
  },
  "signIn": {
    "tagline": "Fillo me qëllim.",
    "signingIn": "Duke u kyçur…",
    "continueApple": "Vazhdo me Apple",
    "continueApple_aria": "Vazhdo me Apple",
    "continueGoogle": "Vazhdo me Google",
    "continueGoogle_aria": "Vazhdo me Google",
    "logo_alt": "Rhemn",
    "footer": "Duke u kyçur, ti pranon kushtet tona të shërbimit dhe <privacyLink>Politikën e Privatësisë</privacyLink>.",
    "divider": "ose"
  },
  "email": {
    "identity": {
      "label": "Adresa e email-it",
      "placeholder": "you@example.com",
      "change": "Ndrysho",
      "change_aria": "Ndrysho adresën e email-it"
    },
    "password": {
      "label": "Fjalëkalimi",
      "labelNew": "Zgjidh një fjalëkalim",
      "placeholder": "Fjalëkalimi",
      "placeholderNew": "Krijo një fjalëkalim",
      "show": "Shfaq fjalëkalimin",
      "hide": "Fshih fjalëkalimin"
    },
    "actions": {
      "continue": "Vazhdo",
      "signIn": "Hyr",
      "createAccount": "Krijo llogari",
      "forgot": "Harrove fjalëkalimin?",
      "backToSignIn": "Kthehu te hyrja",
      "iVerified": "E kam verifikuar email-in",
      "resend": "Dërgo sërish lidhjen",
      "resendIn": "Dërgo sërish pas {{time}}",
      "signInInstead": "Hyr"
    },
    "busy": {
      "checking": "Po kontrollohet…",
      "signingIn": "Po hyn…",
      "creating": "Po krijohet llogaria jote…",
      "sending": "Po dërgohet…"
    },
    "switch": {
      "toCreate": "I ri në Rhemn? <switchBtn>Krijo një llogari</switchBtn>",
      "toSignIn": "Ke tashmë një llogari? <switchBtn>Hyr</switchBtn>"
    },
    "strength": {
      "tooShort": "Të paktën 12 karaktere.",
      "level1": "Mirë. Sa më i gjatë, aq më i fortë.",
      "level2": "Fjalëkalim i fortë.",
      "level3": "Fjalëkalim shumë i fortë."
    },
    "sent": {
      "title": "Kontrollo email-in",
      "body": "Dërguam një lidhje rivendosjeje te {{email}}. Skadon për një orë.",
      "resent": "U dërgua sërish. Kontrollo email-in."
    },
    "verify": {
      "title": "Konfirmo email-in",
      "body": "Dërguam një lidhje te {{email}}. Hape për të përfunduar konfigurimin e llogarisë — ne vazhdojmë automatikisht më tej.",
      "waiting": "Po presim ta hapësh lidhjen…",
      "resent": "U dërgua sërish. Kontrollo email-in."
    },
    "errors": {
      "invalidEmail": "Kjo nuk duket si një adresë email-i.",
      "missingPassword": "Shkruaj fjalëkalimin.",
      "invalidCredential": "Email-i ose fjalëkalimi është i pasaktë.",
      "emailInUse": "Ky email ka tashmë një llogari. <signInBtn>Hyr këtu.</signInBtn>",
      "weakPassword": "Përdor të paktën 12 karaktere.",
      "passwordTooShort": "Përdor të paktën 12 karaktere.",
      "passwordCommon": "Ky fjalëkalim është shumë i lehtë për t’u gjetur. Provo diçka më pak të parashikueshme.",
      "emailNotVerified": "Konfirmo email-in para se të vazhdosh.",
      "providerGoogle": "Ky email është konfiguruar tashmë me Google. Vazhdo me Google më poshtë.",
      "providerApple": "Ky email është konfiguruar tashmë me Apple. Vazhdo me Apple më poshtë.",
      "userDisabled": "Kjo llogari është çaktivizuar.",
      "requiresRecentLogin": "Hyr sërish për ta bërë këtë ndryshim.",
      "sessionExpired": "Sesioni skadoi. Hyr sërish.",
      "expiredActionCode": "Kjo lidhje ka skaduar. Kërko një të re.",
      "invalidActionCode": "Kjo lidhje nuk është më e vlefshme. Kërko një të re.",
      "tooManyRequests": "Shumë përpjekje. Prit disa minuta ose rivendos fjalëkalimin.",
      "network": "Nuk ka lidhje. Kontrollo rrjetin dhe provo sërish.",
      "operationNotAllowed": "Hyrja me email nuk është e disponueshme për momentin.",
      "generic": "Diçka shkoi keq. Provo sërish."
    },
    "a11y": {
      "stepEmail": "Hapi 1 nga 2. Shkruaj adresën e email-it.",
      "stepPasswordSignIn": "Hapi 2 nga 2. Shkruaj fjalëkalimin për të hyrë.",
      "stepPasswordCreate": "Hapi 2 nga 2. Zgjidh një fjalëkalim për llogarinë e re.",
      "stepSent": "Lidhja e rivendosjes u dërgua. Kontrollo email-in.",
      "stepVerify": "Llogaria u krijua. Lidhja e verifikimit u dërgua.",
      "resendReady": "Tani mund ta dërgosh sërish lidhjen."
    }
  }
}
